import React from "react";
import { useMediaQuery } from "react-responsive";
import { KTCard } from "src/resources/helpers";
import User from "../../../../../models/User";
import MemberStatusFilter from "src/app/modules/setting/user/component/MemberStatusFilter";
import TableHeader from "src/app/modules/setting/user/component/TableHeader";
import { TableProvider } from "src/app/modules/setting/user/context/TableContext";
import MemberPagination from "src/app/modules/setting/user/component/pagination/MemberPagination";
import MemberTable from "src/app/modules/setting/user/component/table/MemberTable";
import MemberCard from "src/app/modules/setting/user/component/card/MemberCard";

const MemberList = () => {
  const isMobileView = useMediaQuery({ query: "(max-width: 900px)" });
  console.log("test workspace");
  return (
    <>
      <TableProvider<User> collection="users">
        <div
          style={{
            height: "100%",
            display: "flex",
            flexDirection: "column",
            // justifyContent: "space-between",
          }}
        >
          <div className="card py-2">
            <MemberStatusFilter />
          </div>
          <div className="card py-2 my-2 bg-transparent" />
          <div
            style={{
              height: "100%",
              overflow: "hidden",
            }}
            className="card p-3"
          >
            <TableHeader />

            {isMobileView && <MemberCard />}
            {!isMobileView && <MemberTable />}

            <MemberPagination />
          </div>
        </div>

        {/* <OrderModal />
        <ModalExportOrder /> */}
      </TableProvider>
    </>
  );
}

export default MemberList;